import React, { useState } from "react";
import styles from "./HolidayCalendar.module.css";

import HeadingAndIcon from "../../components/HeadingAndIcon/HeadingAndIcon";
import ToClose from "../../components/ToClose/ToClose";
import HeadingAndData from "../../components/HeadingAndData/HeadingAndData";
import SaveAndCancel from "../../components/SaveAndCancel/SaveAndCancel";
import CalendarInput from "../../components/CalendarInput/CalendarInput";

import { FaRegFileAlt } from "react-icons/fa";
import { useDispatch } from "react-redux";
import { closeModal } from "../../redux/slices/modalSlice";

const HolidayCalendar = () => {
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    name: "",
    startDate: "",
    endDate: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleDateChange = (name, value) => {
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    console.log("Saved Data:", formData);
    // Add save logic here
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      startDate: "",
      endDate: "",
    });
    dispatch(closeModal());
  };

  return (
    <div className={styles.section}>
      <div className={styles.header}>
        <HeadingAndIcon icon={<FaRegFileAlt />} heading="Holiday Calendar" />
        <ToClose onClose={() => dispatch(closeModal())} />
      </div>
      <div className={styles.content}>
      <div className={styles.form}>
        <HeadingAndData
          label="Name"
          name="name"
          placeholder="Holiday name"
          value={formData.name}
          onChange={handleChange}
          required
        />

        <CalendarInput
          fieldLabel="Start Date"
          value={formData.startDate}
          onChange={(val) => handleDateChange("startDate", val)}
          label="choose starting date"
          required
        />

        <CalendarInput
          fieldLabel="End Date"
          value={formData.endDate}
          onChange={(val) => handleDateChange("endDate", val)}
          label="Choose end date"
          required
        />

        <div className={styles.actions}>
          <SaveAndCancel onCancel={handleCancel} onSave={handleSave} />
        </div>
      </div>
    </div>
    </div>
  );
};

export default HolidayCalendar;
